import phoneControllerServices from '../PhoneControllerServices';

import {
  TOGGLE_PHONE_CONNECTION,
  TOGGLE_PHONE_REGISTRATION,
  SET_CALL_REMOTE,
  SET_CALL_STATUS,
  SET_DIAL_PAD_ACTIVE,
  SET_CALL_LOGS,
  ADD_CALL,
  UPDATE_CALL_ID,
  REMOVE_CALL,
  SET_NOTIFYING_CALL_LOG,
  SET_REF,
  CLEAR_REF
} from './types';

const actions = {
  toggleConnection({ commit }, val) {
    commit(TOGGLE_PHONE_CONNECTION, val);
  },

  toggleRegistration({ commit }, val) {
    commit(TOGGLE_PHONE_REGISTRATION, val);
  },

  startOutboundCall({ commit }, remote) {
    commit(SET_CALL_REMOTE, remote);
  },

  addCall({ commit }, { id, session, startTime, direction, number, ref }) {
    commit(ADD_CALL, { id, session, startTime, direction, number, ref });
  },

  updateCallId({ commit }, { number, id }) {
    commit(UPDATE_CALL_ID, { number, id });
  },

  removeCall({ commit }, id) {
    commit(REMOVE_CALL, id);
  },

  setStatus({ commit }, val) {
    commit(SET_CALL_STATUS, val);
  },

  setRef({ commit }, { type, refId }) {
    commit(SET_REF, { type, refId });
  },

  clearRef({ commit }) {
    commit(CLEAR_REF);
  },

  toggleDialPad({ commit }, val) {
    commit(SET_DIAL_PAD_ACTIVE, val);
  },

  async getCallLogs({ commit }) {
    const logs = await phoneControllerServices.getCallLogs();
    commit(SET_CALL_LOGS, logs);
  },

  unnotifyCallLog({ commit }) {
    commit(SET_NOTIFYING_CALL_LOG, false);
  }
};

export default actions;
